import { TOptSelect } from "@/features/financas/views/Indicadores/store/dashboard/types";
import { EInsightsIAAnalysisType } from "../../types";
import { handleNameDate } from "../../../../utils/InsightsUtils";
import { TAgenteDeDreResponse } from "../../services/InsightsAIDreGateway";
import { insightsIAAnalysisOptions } from "../../../../mocks/insightsIAMock";

export type TAnaliseInteligenteInsightsStoreFiltros = {
  IdDaEmpresa: string;
  DataDeCompetencia: string;
  analysisType: EInsightsIAAnalysisType;
  analysisTypeModel: EInsightsIAAnalysisType;
  ResumoDoGrupo?: boolean;
};

export type TAnaliseInteligenteInsightsStore = {
  filtros: TAnaliseInteligenteInsightsStoreFiltros;
  empresasOptions: TOptSelect[];
  periodosOptions: TOptSelect[];
};

export const useInsightsDreAnaliseInteligente = () => {
  const getAnalysisOptions = () => insightsIAAnalysisOptions;

  const analiseInteligenteState = (): TAnaliseInteligenteInsightsStore => ({
    filtros: {
      IdDaEmpresa: "",
      DataDeCompetencia: "",
      analysisType: EInsightsIAAnalysisType.Vertical,
      analysisTypeModel: EInsightsIAAnalysisType.Vertical,
      ResumoDoGrupo: undefined
    },
    empresasOptions: [],
    periodosOptions: []
  });

  const setFiltros = (
    state: TAnaliseInteligenteInsightsStore,
    filtros: TAnaliseInteligenteInsightsStore["filtros"]
  ) => {
    state.filtros = filtros;
  };

  const setEmpresasOptions = (
    state: TAnaliseInteligenteInsightsStore,
    empresasOptions: TAgenteDeDreResponse[]
  ) => {
    const filtroFixo = {
      label: "Resumo do grupo",
      value: "resumo-do-grupo"
    };
    const empresasUnicasComMarca = Array.from(
      new Map(
        empresasOptions.map((agente) => [
          agente.idEmpresa,
          {
            label: agente.nomeFantasia,
            value: agente.idEmpresa,
            marca: agente.marca
          }
        ])
      ).values()
    );

    const marcasSaoIguais =
      empresasUnicasComMarca.length > 0 &&
      empresasUnicasComMarca.every(
        (empresa) => empresa.marca === empresasUnicasComMarca[0].marca
      );

    const empresasUnicas = empresasUnicasComMarca.map(({ label, value }) => ({
      label,
      value
    }));

    state.empresasOptions = marcasSaoIguais
      ? [filtroFixo, ...empresasUnicas]
      : empresasUnicas;
  };

  const setPeriodosOptions = (
    state: TAnaliseInteligenteInsightsStore,
    periodosOptions: TAgenteDeDreResponse[]
  ) => {
    const competenciasUnicas = Array.from(
      new Set(periodosOptions.map((agente) => agente.competenciaAte))
    );

    state.periodosOptions = competenciasUnicas.map((competenciaAte) => ({
      label: handleNameDate(competenciaAte),
      value: competenciaAte
    }));
  };

  return {
    getAnalysisOptions,
    analiseInteligenteState,
    setFiltros,
    setEmpresasOptions,
    setPeriodosOptions
  };
};
